import React from 'react'
import t from 'prop-types'
import Offset from '../../Layouts/Offset'
import StatDefault from '../../Infographics/StatDefault'
import Testimonial from '../../Testimonials/Testimonial'
import Image from '../../Images/Image'

const SuccessStoryOverview = ({
  heading,
  content,
  image,
  stats,
  testimonial,
}) => {
  return (
    <Offset direction="left">
      <div className="bg-gray-100 pr-20">
        <Offset>
          {heading && content && (
            <div className="pt-24 pb-16 border-b border-gray-300">
              <div className="max-w-screen-lg md:mr-20">
                <h3 className="mb-6 text-xs md:text-sm lg:text-base leading-tight tracking-widest lg:tracking-wider font-medium uppercase text-gray-700">
                  {heading}
                </h3>
                <div
                  className="max-w-screen-md font-sans font-normal text-lg md:text-xl lg:text-2xl leading-normal text-gray-600"
                  dangerouslySetInnerHTML={{ __html: content }}
                ></div>
              </div>
            </div>
          )}
          {stats && (
            <div className={testimonial && `border-b border-gray-300`}>
              <div className="md:grid md:grid-cols-4 gap-20 pt-12 pb-16 md:mr-20">
                {stats.map((stat, index) => (
                  <div
                    className="mb-16 md:mb-0 last:mb-0 mx-auto w-2/3 md:w-auto"
                    key={index}
                  >
                    <StatDefault {...stat} />
                  </div>
                ))}
              </div>
            </div>
          )}
          {testimonial && (
            <div className="pt-8 pb-16 max-w-screen-md">
              <Testimonial {...testimonial} />
            </div>
          )}
        </Offset>
        {image?.src && (
          <div>
            <Image className="w-full h-auto" {...image} />
          </div>
        )}
      </div>
    </Offset>
  )
}

SuccessStoryOverview.propTypes = {
  heading: t.string,
  content: t.string,
  image: t.object,
  stats: t.object,
  testimonial: t.object,
}

SuccessStoryOverview.defaultProps = {}

export default SuccessStoryOverview
